import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Breadcrumb from 'src/Components/HelpCenter/Breadcrumb'
import SearchBar from 'src/Components/HelpCenter/SearchBar'
import { categories } from './HelpCenterHome'
import { Box, Tab, Tabs } from '@mui/material'
import { IoChevronDown, IoChevronUp } from 'react-icons/io5'
import ResolvedTopics from 'src/Components/HelpCenter/ResolvedTopics'
import { helpCenterData } from 'src/Components/HelpCenter/HelpCenterData'
import { useHelpCenterStore } from 'src/Containers/HelpCenter/helpCenterStore'

const Risk = () => {
    const location = useLocation()
    const navigate = useNavigate()

    // Get active tab from URL
    const activeTab = categories.find(cat => location.pathname.includes(cat.path))?.path || '/GRC/help-center/dashboard'

    const handleChange = (event, newValue) => {
        navigate(newValue) // Navigate to the selected tab path
    }

    const [ visibleItems, setVisibleItems ] = useState(6)
    const [ expanded, setExpanded ] = useState(false)

    // Extract module from the URL
    const moduleFromURL = location.pathname.split('/').pop() // Get last segment
    const activeModule = helpCenterData.find(module =>
        module.module.toLowerCase() === moduleFromURL
    )

    const toggleShowMore = () => {
        if (expanded) {
            setVisibleItems(6)
        } else {
            setVisibleItems(activeModule?.topics?.length)
        }
        setExpanded(!expanded)
    }

    return (
        <div className="text-primary bg-[#fff] h-full">
            <Breadcrumb />
            <Box sx={{ width: '100%' }} className="border-b">
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    textColor="primary"
                    indicatorColor="primary"
                    aria-label="help center tabs"
                    sx={{
                        '& .MuiTabs-indicator': { backgroundColor: '#007a78' }, // Custom indicator color
                        '& .Mui-selected': { color: '#007a78 !important', fontWeight: '600' } // Active tab color
                    }}
                >
                    {categories.map((cat, idx) => (
                        <Tab key={idx} value={cat.path} label={cat.name} className='!capitalize' />
                    ))}
                </Tabs>
            </Box>
            <div className="grid grid-cols-2 justify-between">
                <div className="p-4 ml-4">
                    <SearchBar width={'w-3/4'} searchResults={helpCenterData}/>
                    <div className="p-4 overflow-y-scroll h-[65svh] flex flex-col ">
                        {activeModule?.topics?.slice(0, visibleItems)?.map((q, idx) => (
                            <Link
                                key={idx}
                                to={`${activeTab}/${q?.title?.replace(/\s+/g, '-').toLowerCase()}`}
                                onClick={() => useHelpCenterStore.getState().setSelectedQuestion(q)}
                            >
                                <div
                                    className="border border-[#b2d9d8] hover:border-[#00a2a1] hover:bg-primary-foreground p-4 rounded-lg text-lg font-medium mb-4 hover:bg-gray-100 transition-all duration-300 ease-in-out flex items-center justify-between"
                                >
                                    <span className='capitalize'>{q.title}</span>
                                    <span>→</span>
                                </div>
                            </Link>
                        ))}

                        {/* Show More / Show Less Button */}
                        {activeModule?.topics?.length > 6 && (
                            <button
                                onClick={toggleShowMore}
                                className="flex items-center self-center justify-center text-[#333] mt-4 w-fit transition-all duration-300 border border-[#fff] hover:border-[#00a2a1] hover:bg-primary-foreground px-4 py-2 rounded-full"
                            >
                                {expanded ? 'See Less' : 'See More'}
                                {expanded
                                    ? (
                                        <IoChevronUp className="ml-1 text-primary text-lg" />
                                    )
                                    : (
                                        <IoChevronDown className="ml-1 text-primary text-lg" />
                                    )}
                            </button>
                        )}
                    </div>
                </div>
                <div className="lg:w-2/5 md:w-2/3 justify-self-end items-start md:mx-20 lg:mx-48 my-28">
                    <ResolvedTopics disabled={true}/>
                </div>
            </div>
        </div>
    )
}

export default Risk
